import React from "react";
import BsRow, { RowProps as BsRowProps } from "reactstrap/lib/Row";

interface RowProps extends BsRowProps {}

const Row = (props: RowProps) => {
    return <BsRow {...props} />;
};

export default Row;
